import styles from './scrollbar.module.css';

export const scrollbar = {
  default: styles['default-scrollbar'],
  dark: styles['dark-scrollbar'],
};
